<template lang="pug">
  .table-responsive
    table#tbTarjetasMovimientos.table.is-striped.is-fullwidth.is-narrow
      thead
        tr
          th
            | #
          th 
            | Fecha
          th
            | Placa
          th 
            | Km. Anterior
          th 
            | Km. Nuevo
          th 
            | Km. Recorridos
      tbody
        tr(v-for="(mov, index) in movs" :key="index")
          td.is-size-7
            span.tag.is-light {{ index + 1 }}
          td.is-size-7
            span.tag.is-light {{ mov.fechaTransaccion }}
          td.is-size-7
            span.tag.is-light {{ mov.placa }}
          td.is-size-7
            a.button.is-warning.is-rounded.is-small(v-if="mov.recorrido < 0" @click="updateKilometraje(mov, index)") {{ mov.kilometrajeAnt }}
            span.tag(v-else) {{ mov.kilometrajeAnt }}
          td.is-size-7
            a.button.is-warning.is-rounded.is-small(v-if="mov.recorrido < 0" @click="updateKilometraje(mov, index)") {{ mov.kilometrajeActual }}
            span.tag(v-else) {{ mov.kilometrajeActual }}
          td.is-size-7
            a.button.is-warning.is-rounded.is-small(v-if="mov.recorrido < 0" @click="updateKilometraje(mov, index)") {{ mov.recorrido }}
            span.tag(v-else) {{ mov.recorrido }}
    .notification(v-show="movs.length < 1")
      strong  No se encontraron registros.
</template>

<script>
  

  export default {
    name: 'TbTarjetasMovimientos',
    props: {
      movs: {
        type: Array,
        default: []
      },
      movSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    methods: {
      updateKilometraje (mov, index) {
        const myObj = {
          index, 
          data: mov
        }
        this.$emit('seleccionarItem', myObj)
      },
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/TbTarjetasMovimientos.vue